import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap';

import { connect } from 'react-redux';
import { toggleAlert } from './store/actions/ui';

import CompsTab from './comps_tab';
import SearchPage from 'components/search_page';
import { useEdgeCrmStyleOverrides } from 'bundles/crm/lite_crm_overrides/helpers';

export function Comps({ alertMessage, error, features, toggleAlert }) {
  if (features.edgeCrm) {
    useEdgeCrmStyleOverrides();
  }

  useEffect(() => {
    if (alertMessage) {
      setTimeout(dismissAlert, 6000);
    }
  }, [alertMessage]);

  function dismissAlert() {
    toggleAlert('', false);
  }

  return <>
    {alertMessage &&
      <Alert bsStyle={error ? 'danger' : 'success'} className="mb-0" onDismiss={dismissAlert}>
        <span className="left-buffer-lg">
          {alertMessage}
        </span>
      </Alert>
    }
    <SearchPage>
      <div className="results-tab-container comps">
        <CompsTab />
      </div>
    </SearchPage>
  </>;
}

Comps.propTypes = {
  alertMessage: PropTypes.string,
  error: PropTypes.bool,
  features: PropTypes.shape({
    edgeCrm: PropTypes.bool,
  }).isRequired,
  toggleAlert: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  alertMessage: state.ui.alertMessage,
  error: state.ui.error,
  features: state.features,
});

const mapDispatchToProps = { toggleAlert };

export default connect(mapStateToProps, mapDispatchToProps)(Comps);
